<template>
  <div class="review-list">
    <template v-if="reviews.length > 0">
      <review-item
        v-for="review in reviews"
        :key="review.id"
        :review="review"
      />
    </template>
    <template v-else>
      <b-row class="text-center">
        <b-col
          ><p>
            {{ label }}
          </p></b-col
        >
      </b-row>
    </template>

    <custom-pagination
      :meta="reviewsMeta"
      :loading="loading"
      class="review-pagination"
      @change="setPage"
    ></custom-pagination>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Review list
 * ==================================================================================
 **/

import { mapState, mapMutations, mapActions } from 'vuex'
import Job from '@/models/Job'
import ReviewItem from '@/components/cards/ReviewItem'
import CustomPagination from '@/components/inputs/CustomPagination'

export default {
  components: {
    ReviewItem,
    CustomPagination
  },
  props: {
    job: {
      type: [Job, Object],
    }
  },
  computed: {
    ...mapState({
      reviews: state => state.review.list,
      reviewsMeta: state => state.review.listMeta
    }),

    label() {
      if (this.loading) return 'Fetching reviews right now...'
      return this.error ? this.error : 'Tool has no reviews yet...'
    }
  },
  data: function() {
    return {
      loading: false,
      error: null
    }
  },
  methods: {
    ...mapActions({
      getReviews: 'review/getReviews'
    }),
    ...mapMutations({
      clearReviews: 'review/clearReviewList'
    }),
    async fetchReviews(page = 1) {
      if (this.loading) return

      this.clearReviews()
      this.loading = true
      this.error = null

      let params = {
        id: this.job.permalink,
        page: page,
        limit: 4
      }

      await this.getReviews(params)
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.error = `Can't seem to fetch the FAQs, please try later or refresh the page`
        })
    },

    setPage(page) {
      this.fetchReviews(page)
    }
  },
  created() {
    this.fetchReviews()
  }
}
</script>
<style scoped lang="scss">
.review-list {
  .review-item {
    margin-bottom: 20px;
  }

  .review-pagination {
    margin-top: 40px;
  }
}
</style>
